<template>
    <div class="page-container">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">系统设置</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>币种设置</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="page-content" shadow="never">
            <div class="page-actions">
                <create-currency @refresh="refreshList"/>
                <el-input placeholder="请输入币种" clearable v-model="code">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button @click="handleSearch" type="primary">搜索</el-button>
                <currency-sprite></currency-sprite>
                <currency-batch @refresh="refreshList"></currency-batch>
            </div>
            <el-tabs v-model="areaType" @tab-click="handleAreaTypeChange" type="card">
                <el-tab-pane label="主区" name="0"/>
                <el-tab-pane label="创新区" name="1"/>
                <el-tab-pane label="DRWA" name="2"/>
                <el-tab-pane label="股票RWA" name="3"/>
            </el-tabs>
            <currency-list @refresh="refreshList"/>
        </el-card>
        <currency-detail @refresh="refreshList"/>
    </div>
</template>

<script>
    import './store';
    import CurrencyList from './components/list';
    import CreateCurrency from './components/create';
    import CurrencyDetail from './components/detail';
    import CurrencySprite from './components/sprite';
    import CurrencyBatch from './components/batch';
    import {mapActions, mapState} from 'vuex';
    import {PAGINATION} from './constants';

    export default {
        name: 'CurrencySetting',
        components: {
            CurrencyList,
            CreateCurrency,
            CurrencyDetail,
            CurrencySprite,
            CurrencyBatch
        },
        data() {
            return {
                code: null,
                areaType: '0'
            };
        },
        computed: {
            ...mapState('currencySetting', ['pagination'])
        },
        methods: {
            ...mapActions('currencySetting', ['list', 'getContractCodeList']),
            refreshList(data = {}) {
                this.list({
                    code: this.code,
                    areaType: Number(this.areaType),
                    ...this.pagination,
                    ...data
                });
            },
            handleSearch() {
                this.list({
                    code: this.code,
                    areaType: Number(this.areaType),
                    ...this.pagination,
                    page: 1
                });
            },
            handleAreaTypeChange(tab) {
                this.code = null;
                this.areaType = tab.name;
                this.list({
                    code: this.code,
                    areaType: Number(tab.name),
                    ...this.pagination,
                    page: 1
                });
            }
        },
        created() {
            this.code = null;
            this.list({areaType: Number(this.areaType), ...PAGINATION});
            this.getContractCodeList();
        }
    };
</script>

<style lang="less" scoped>
</style>
